import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';
import Info from 'material-ui/svg-icons/action/info';

import { field } from './InfoDialog.less';
import { colors, dimensions } from 'styles/provider';

const styles = {
  color: colors.clrSecondary,
  wrapper: {
    display: 'inline-block',
  },
  button: {
    width: dimensions.infoButtonSize,
    height: dimensions.infoButtonSize,
    boxSizing: 'content-box',
    padding: 0,
  },
  icon: {
    width: dimensions.infoIconSize,
    height: dimensions.infoIconSize,
  },
};

// innerWidth doesn't change automatically when window size changes. Needs refresh
const dialogStyles = {
  width: window.innerWidth < 767 ? '95%' : 'auto',
  maxWidth: window.innerWidth < 767 ? '95%' : dimensions.infoDialogMaxWidth,
};

class InfoDialog extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.handleView = f => () => this.setState(prev => ({ open: f }));
    this.actions = [
      <RaisedButton
        label={props.intl.formatMessage({ id: 'infoDialog.close' })}
        primary
        onClick={this.handleView(false)}
      />,
    ];
  }

  render() {
    const {
      value,
      buttonStyle,
      viewStyle,
      title,
      buttonComponent,
      intl: { formatMessage },
    } = this.props;
    const { handleView, actions } = this;

    return (
      <div style={styles.wrapper}>
        {buttonComponent ? (
          buttonComponent(handleView(true))
        ) : (
          <IconButton style={{ ...styles.button, ...buttonStyle }} iconStyle={styles.icon} onClick={handleView(true)}>
            <Info color={styles.color} />
          </IconButton>
        )}
        <Dialog
          title={title ? formatMessage({ id: title }) : null}
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={handleView(false)}
          contentStyle={dialogStyles}
          autoScrollBodyContent
        >
          <div style={{ color: colors.clrText, ...viewStyle }} className={field}>
            {value}
          </div>
        </Dialog>
      </div>
    );
  }
}

InfoDialog.propTypes = {
  intl: intlShape,
  value: PropTypes.any,
  buttonStyle: PropTypes.object,
  viewStyle: PropTypes.object,
  title: PropTypes.string,
  buttonComponent: PropTypes.func, // Custom component to replace button which opens the dialog
};

export default injectIntl(InfoDialog);
